<script>
	import { onMount, onDestroy, getContext } from 'svelte';
	import mapboxgl from 'mapbox-gl';

	import Vessel from "../../Models/Vessel";
	import VesselProperty from "../../Models/Enums/VesselProperty";

	import MapStore from '../Store';
	import PopupStore from './PopupStore';
	import PopupType from "./PopupType";
	import MapLayer from "../Enums/MapLayer";

	import AlertsStore from '../../Alerts/Store';
	import VesselHistoryStore from '../../UI/VesselHistory/Store';
	import VesselsNearbyStore from '../../UI/VesselsNearby/Store';

	const map = MapStore.mapbox.instance;

	// Add events to the Map.
	onMount(()=>{
		const popupToggle = (type, vesselGroup, e, visible) => {

			//TODO: remove need for this; all data should be in geojson object
			const vessel = visible
				? vesselGroup.find({[VesselProperty.MMSI]: e.features[0].properties[VesselProperty.MMSI]})
				: null;
			let imo = null;
			let mmsi = null;
			let name = null;
			let coords = null; // e.lngLat;
			let speed = null;
			let courseHeading = null;
			let timestamp = 0;
			let extraData = {};
			if (type === PopupType.VESSEL && vessel) {
				// console.log("vessel", vessel);
				imo = vessel.imo;
				mmsi = vessel.mmsi;
				name = vessel.name;
				coords = vessel.coordinates;
				timestamp = vessel.timestamp;
				speed = vessel.speed;
			}
			else if (type === PopupType.HISTORIC && e.features) {
				// console.log("e.features[0]", e.features[0]);
				imo = e.features[0].properties[VesselProperty.IMO];
				mmsi = e.features[0].properties[VesselProperty.MMSI];
				name = e.features[0].properties[VesselProperty.NAME];
				coords = e.features[0].geometry.coordinates;
				timestamp = e.features[0].properties[VesselProperty.TIMESTAMP];
				speed = e.features[0].properties[VesselProperty.SPEED];
			}
			else if (type === PopupType.HEATMAP_POINT && e.features) {
				// console.log("e.features[0]", e.features[0]);
				imo = e.features[0].properties.imo;
				mmsi = e.features[0].properties.mmsi;
				name = e.features[0].properties.name;
				coords = e.features[0].geometry.coordinates;
				timestamp = e.features[0].properties.timestamp;
				speed = e.features[0].properties.speed;
				courseHeading = e.features[0].properties.course + "/" + e.features[0].properties.heading;

				if (typeof e.features[0].properties.countPoints !== "undefined") {
					extraData.Count = e.features[0].properties.countPoints;
					extraData.StartTime = e.features[0].properties.startTime;
					extraData.EndTime = e.features[0].properties.endTime;
				}
			}

			PopupStore.actions.set(type, vessel, imo, mmsi, name, coords, speed, courseHeading, timestamp, visible, extraData);
		};

		const vesselEnter = (e, group, propertyName) => {
			const property = e.features[0].properties[propertyName];
			const vessel = group.find({[propertyName]: property});
			const activeSnapshot = (vessel && vessel.hasActiveSnapshot());
			// console.log("Active snapshot", activeSnapshot);
			popupToggle(activeSnapshot ? PopupType.HISTORIC : PopupType.VESSEL, group, e, true);
		};
		const vesselMove = (e, group, propertyName) => {
			const property = e.features[0].properties[propertyName];
			const vessel = group.find({[propertyName]: property});
			const activeSnapshot = (vessel && vessel.hasActiveSnapshot());
			popupToggle(activeSnapshot ? PopupType.HISTORIC : PopupType.VESSEL, group, e, true);
		};
		const vesselLeave = (e, group, propertyName) => {
			popupToggle(PopupType.VESSEL, group, e, false);
			popupToggle(PopupType.HISTORIC, group, e, false);
		};

		$map.on("mouseenter", MapLayer.VESSELS_LIVE, (e) => { vesselEnter(e, AlertsStore.vesselGroup, VesselProperty.MMSI); });
		$map.on("mousemove", MapLayer.VESSELS_LIVE, (e) => { vesselMove(e, AlertsStore.vesselGroup, VesselProperty.MMSI); });
		$map.on("mouseleave", MapLayer.VESSELS_LIVE, (e) => { vesselLeave(e, AlertsStore.vesselGroup, VesselProperty.MMSI); });

		$map.on("mouseenter", MapLayer.VESSELS_HISTORY_POINTS, (e) => { popupToggle(PopupType.HISTORIC, AlertsStore.vesselGroup, e, true); });
		$map.on("mousemove", MapLayer.VESSELS_HISTORY_POINTS, (e) => { popupToggle(PopupType.HISTORIC, AlertsStore.vesselGroup, e, true); });
		$map.on("mouseleave", MapLayer.VESSELS_HISTORY_POINTS, (e) => { popupToggle(PopupType.HISTORIC, AlertsStore.vesselGroup, e, false); });


		// // TODO: consider moving to individual controllers
		$map.on("mouseenter", MapLayer.VESSELS_NEARBY, (e) => { popupToggle(PopupType.HISTORIC, VesselsNearbyStore.results.vesselGroup, e, true); });
		$map.on("mousemove", MapLayer.VESSELS_NEARBY, (e) => { popupToggle(PopupType.HISTORIC, VesselsNearbyStore.results.vesselGroup, e, true); });
		$map.on("mouseleave", MapLayer.VESSELS_NEARBY, (e) => { popupToggle(PopupType.HISTORIC, VesselsNearbyStore.results.vesselGroup, e, false); });

		// // TODO: consider moving to individual controllers
		$map.on("mouseenter", MapLayer.VESSEL_HISTORY_SNAPSHOT, (e) => { vesselEnter(e, VesselHistoryStore.vesselGroup, VesselProperty.SPIRE_ID); });
		$map.on("mousemove", MapLayer.VESSEL_HISTORY_SNAPSHOT, (e) => { vesselMove(e, VesselHistoryStore.vesselGroup, VesselProperty.SPIRE_ID); });
		$map.on("mouseleave", MapLayer.VESSEL_HISTORY_SNAPSHOT, (e) => { vesselLeave(e, VesselHistoryStore.vesselGroup, VesselProperty.SPIRE_ID); });
		$map.on("mouseenter", MapLayer.HEATMAP_POINTS, (e) => { popupToggle(PopupType.HEATMAP_POINT, VesselHistoryStore.vesselGroup, e, true); });
		$map.on("mousemove", MapLayer.HEATMAP_POINTS, (e) => { popupToggle(PopupType.HEATMAP_POINT, VesselHistoryStore.vesselGroup, e, true); });
		$map.on("mouseleave", MapLayer.HEATMAP_POINTS, (e) => { popupToggle(PopupType.HEATMAP_POINT, VesselHistoryStore.vesselGroup, e, false); });
	});



	const popup = new mapboxgl.Popup({
		closeButton: false,
		closeOnClick: false
	});

	PopupStore.helpers.getInstance = () => {
		return popup;
	}

	// let visible
	let unsubscribe = PopupStore.subscribe(value => {
		if (value.visible) {
			$map.getCanvas().style.cursor = "pointer"; // Hack?!

			const popupType = value.type;
			let contents = "";
			const imo = (value.data.all.imo !== "null" && value.data.all.imo !== null && value.data.all.imo !== "")?value.data.all.imo:"Unknown";
			const mmsi = (value.data.all.mmsi !== "null")?value.data.all.mmsi:"Unknown";
			if (popupType === PopupType.VESSEL) {
				const vessel = value.data[PopupType.VESSEL].vessel;
				const properties = vessel.feature.properties;
				contents = `<strong>Name:</strong> ${value.data.all.name}
					<br/><strong>IMO:</strong> ${imo}
					<br/><strong>MMSI:</strong> ${mmsi}
					<br/><strong>Speed:</strong> ${Vessel.formatKnots(value.data.all.speed)}
					<br/>${Vessel.formatTime((""+value.data.all.timestamp).substr(0, 19))}
					<br/><strong>Hours Since Update:</strong> ${ properties.update == undefined ? "> 24" : Math.abs(Math.round(properties.update))}`;
			}
			else if (popupType === PopupType.HISTORIC) {

				contents = `<strong>Name:</strong> ${value.data.all.name}
					<br/><strong>IMO:</strong> ${imo}
					<br/><strong>Speed:</strong> ${Vessel.formatKnots(value.data.all.speed)}
					<br/>${Vessel.formatTime((""+value.data.all.timestamp).substr(0, 19))}`;
			}
			else if (popupType == PopupType.HEATMAP_POINT) {
				contents = `<strong>Latest Name:</strong> ${value.data.all.name}
							<br/><strong>IMO:</strong> ${imo}
							<br/><strong>Speed:</strong> ${Vessel.formatKnots(value.data.all.speed)}`;
							
				if (value.data.all.extraData && value.data.all.extraData.Count > 0) {
					contents +=`<br/><br/><strong>Data Points</strong>: ${value.data.all.extraData.Count}`;
					contents +=`<br/><strong>Between</strong>: ${Vessel.formatTime((""+value.data.all.extraData.StartTime).substr(0, 19))}`;
					contents +=`<br/><strong>And</strong>: ${Vessel.formatTime((""+value.data.all.extraData.EndTime).substr(0, 19))}`;
					// contents +=`<br/><br/><strong>End</strong>: ${value.data.all.extraData.EndTime}`;
				}
				else {
					contents +=`<br/>${Vessel.formatTime((""+value.data.all.timestamp).substr(0, 19))}`;
				}

					// <br/><strong>Course/heading (deg):</strong> ${value.data.all.courseHeading}
			}
			else if (popupType == PopupType.CUSTOM) {
				contents = PopupStore.helpers.generateKeyValueList(value.data.custom);
			}
			else if (popupType == PopupType.CUSTOM_HTML) {
				contents += value.data.customHtml.html;
				popup.setMaxWidth(value.data.customHtml.width + "px")
			}
			else {
				contents = "Unknown popup type";
			}
			popup.setHTML(contents);

			// Prevent popup trying to render twice on far zoomout
			let coordinates = value.data.all.coordinates;
			popup.setLngLat(coordinates);
			popup.addTo($map);

			popup.removeClassName(PopupType.VESSEL + "-popup");
			popup.removeClassName(PopupType.HISTORIC + '-popup');
			popup.removeClassName(PopupType.HEATMAP_POINT + '-popup');
			popup.addClassName(popupType + '-popup');


		} else {
			$map.getCanvas().style.cursor = MapStore.helpers.getDefaultCursor(); // Hack?!
			popup.remove();
		}
	});
	onDestroy(unsubscribe);





</script>
